import { useCallback, useContext, useEffect, useState } from "react";
import { IButtonFavorite } from "../../models/IButtonFavorite";

//components
import { toast } from "react-toastify";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";

import { CardButton } from "./styles";

//services
import {
	saveFavoriteDiscipline,
	saveFavoriteUnity,
	saveFavoriteTheme,
	saveFavoriteObject,
} from "../../services/favorites.service";
import { Modal } from "../modal";
import { useTranslation } from "react-i18next";
import { MdFavorite, MdFavoriteBorder } from "react-icons/md";
import UsuarioContext from "../../../context/userContext/context";
import {
	getStorageFavoriteMaterials,
	removeStorageFavoriteMaterials,
	setStorageFavoriteMaterials,
} from "../../utils/storageFavoriteMaterials";

export const ButtonFavorite: React.FC<IButtonFavorite> = ({
	material,
	removeFavorite,
	isMaterialView,
	variant,
	showText,
	materialType,
}) => {
	const { t: translation } = useTranslation();
	const { user } = useContext(UsuarioContext);
	const [tipText] = useState<string>("Salvar Material");
	const [checked, setChecked] = useState<boolean>(
		material && material.favorite ? true : false
	);
	const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
	const [loadingAddMaterial, setLoadingAddMaterial] =
		useState<boolean>(false);
	const [loadingModal, setLoadingModal] = useState<boolean>(false);
	// const [favoritesDisciplines, setFavoritesDisciplines] = useLocalStorage<number[]>('@favorites_disciplines', [])
	// const [favoritesItems, setFavoritesItems] = useLocalStorage<number[]>('@favorites_items', [])
	// const [favoritesThemes, setFavoritesThemes] = useLocalStorage<number[]>('@favorites_themes', [])
	// const [favoritesMedias, setFavoritesMedias] = useLocalStorage<number[]>('@favorites_medias', [])

	useEffect(() => {
		if (material) {
			if (!material.type_product && materialType) {
				material.type_product = materialType;
			}
			if (!material.type_product && material.product_type) {
				material.type_product = material.product_type;
			}
		}
	}, []);

	useEffect(() => {
		if (user.token && material) {
			let favoriteMaterial: any;

			switch (material.type_product) {
				case "Discipline":
					favoriteMaterial = getStorageFavoriteMaterials(
						"@favorites_disciplines"
					);
					if (favoriteMaterial) {
						if (favoriteMaterial.includes(material.id)) {
							material.favorite = true;
							setChecked(true);
						}
					}
					break;
				case "Item":
					favoriteMaterial =
						getStorageFavoriteMaterials("@favorites_items");
					if (favoriteMaterial) {
						if (favoriteMaterial.includes(material.id)) {
							material.favorite = true;
							setChecked(true);
						}
					}
					break;
				case "Theme":
					favoriteMaterial =
						getStorageFavoriteMaterials("@favorites_themes");
					if (favoriteMaterial) {
						if (favoriteMaterial.includes(material.id)) {
							material.favorite = true;
							setChecked(true);
						}
					}
					break;
				case "Media":
					favoriteMaterial =
						getStorageFavoriteMaterials("@favorites_medias");
					if (favoriteMaterial) {
						if (favoriteMaterial.includes(material.id)) {
							material.favorite = true;
							setChecked(true);
						}
					}
					break;
				default:
					break;
			}
		}
	}, [material]);

	const handleButtonFavorite = useCallback((e?: any) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		if (material && user.token) {
			if (material.favorite && removeFavorite) {
				material.favorite = false;
				removeFavorite(material.favorite_id, material.type_product);
				setShowModalConfirm(false);
				setChecked(false);
			} else {
				if (
					material.type_product === "Discipline" &&
					!material.favorite
				) {
					setLoadingAddMaterial(true);
					saveFavoriteDiscipline(material.id).then((res) => {
						toast.success("Disciplina adicionada com sucesso!", {
							position: "bottom-center",
						});
						setLoadingAddMaterial(false);
						material.favorite = true;
						material.favorite_id = res.id;
						setChecked(true);
						setLoadingModal(false);
					});
					return;
				}

				if (material.type_product === "Item" && !material.favorite) {
					setLoadingAddMaterial(true);
					saveFavoriteUnity(material.id).then((res) => {
						toast.success("Unidade adicionada com sucesso!", {
							position: "bottom-center",
						});
						setLoadingAddMaterial(false);
						material.favorite = true;
						material.favorite_id = res.id;
						setChecked(true);
						setLoadingModal(false);
					});
					return;
				}

				if (material.type_product === "Theme" && !material.favorite) {
					setLoadingAddMaterial(true);
					saveFavoriteTheme(material.id).then((res) => {
						toast.success("Tema adicionado com sucesso!", {
							position: "bottom-center",
						});
						setLoadingAddMaterial(false);
						material.favorite = true;
						material.favorite_id = res.id;
						setChecked(true);
						setLoadingModal(false);
					});
					return;
				}

				if (material.type_product === "Media" && !material.favorite) {
					setLoadingAddMaterial(true);
					saveFavoriteObject(material.id).then((res) => {
						toast.success("Objeto adicionado com sucesso!", {
							position: "bottom-center",
						});
						setLoadingAddMaterial(false);
						material.favorite = true;
						material.favorite_id = res.id;
						setChecked(true);
						setLoadingModal(false);
					});
					return;
				}
			}
		} else if (material && !user.token) {
			if (material.favorite) {
				removeStorageFavoriteMaterials(
					material.type_product,
					material.id
				);
				material.favorite = false;
				setChecked(false);
				setLoadingModal(false);
				setShowModalConfirm(false);
			} else {
				if (
					material.type_product === "Discipline" &&
					!material.favorite
				) {
					setLoadingAddMaterial(true);
					const favoriteDisciplines = getStorageFavoriteMaterials(
						"@favorites_disciplines"
					);
					if (favoriteDisciplines) {
						if (!favoriteDisciplines.includes(material.id)) {
							setStorageFavoriteMaterials(
								"@favorites_disciplines",
								[...favoriteDisciplines, material.id]
							);
							material.favorite = true;
							setChecked(true);
						}
					}
					setLoadingAddMaterial(false);
					return;
				}

				if (material.type_product === "Item" && !material.favorite) {
					setLoadingAddMaterial(true);
					const favoriteItem =
						getStorageFavoriteMaterials("@favorites_items");
					if (favoriteItem) {
						if (!favoriteItem.includes(material.id)) {
							setStorageFavoriteMaterials("@favorites_items", [
								...favoriteItem,
								material.id,
							]);
							material.favorite = true;
							setChecked(true);
						}
					}
					setLoadingAddMaterial(false);
					return;
				}

				if (material.type_product === "Theme" && !material.favorite) {
					setLoadingAddMaterial(true);
					const favoriteTheme =
						getStorageFavoriteMaterials("@favorites_themes");
					if (favoriteTheme) {
						if (!favoriteTheme.includes(material.id)) {
							setStorageFavoriteMaterials("@favorites_themes", [
								...favoriteTheme,
								material.id,
							]);
							material.favorite = true;
							setChecked(true);
						}
					}
					setLoadingAddMaterial(false);
					return;
				}

				if (material.type_product === "Media" && !material.favorite) {
					setLoadingAddMaterial(true);
					const favoriteMedia =
						getStorageFavoriteMaterials("@favorites_medias");
					if (favoriteMedia) {
						if (!favoriteMedia.includes(material.id)) {
							setStorageFavoriteMaterials("@favorites_medias", [
								...favoriteMedia,
								material.id,
							]);
							material.favorite = true;
							setChecked(true);
						}
					}
					setLoadingAddMaterial(false);
					return;
				}
			}
		}
	}, []);

	const handleConfirmRemove = () => {
		setShowModalConfirm(true);
	};

	useEffect(() => {
		if (material && material.favorite) {
			setChecked(true);
		}
	}, [material]);

	return (
		<CardButton>
			<OverlayTrigger
				placement={"left"}
				overlay={
					material && material.favorite ? (
						<Tooltip id="remove-material">Remover Material</Tooltip>
					) : (
						<Tooltip>{tipText}</Tooltip>
					)
				}
			>
				<button
					type="button"
					onClick={
						material && material.favorite
							? handleConfirmRemove
							: handleButtonFavorite
					}
				>
					{loadingAddMaterial ? (
						<Spinner
							animation="border"
							variant="primary"
							style={{ width: "2rem", height: "2rem" }}
						/>
					) : material && material.favorite && isMaterialView ? (
						<MdFavorite
							style={{
								color: `${
									variant === "white" ? "white" : "#606060"
								}`,
							}}
							size={24}
						/>
					) : checked ? (
						showText ? (
							<>
								<MdFavorite
									size={24}
									style={{
										color: `${
											variant === "white"
												? "white"
												: variant === "blueberry"
												? "#6473FF"
												: "#606060"
										}`,
									}}
								/>
								<span style={{ fontSize: "16px" }}> Salvo</span>
							</>
						) : (
							<MdFavorite
								size={24}
								style={{
									color: `${
										variant === "white"
											? "white"
											: variant === "blueberry"
											? "#6473FF"
											: "#606060"
									}`,
								}}
							/>
						)
					) : showText ? (
						<>
							<MdFavoriteBorder
								size={24}
								style={{
									color: `${
										variant === "white"
											? "white"
											: variant === "blueberry"
											? "#6473FF"
											: "#606060"
									}`,
								}}
							/>
							<span style={{ fontSize: "16px" }}> Salvar</span>
						</>
					) : (
						<MdFavoriteBorder
							size={24}
							style={{
								color: `${
									variant === "white"
										? "white"
										: variant === "blueberry"
										? "#6473FF"
										: "#606060"
								}`,
							}}
						/>
					)}
				</button>
			</OverlayTrigger>

			<Modal
				headerTitle="Aviso"
				submitButtonText={translation("remove")}
				show={showModalConfirm}
				onHide={() => setShowModalConfirm(false)}
				onSubmit={handleButtonFavorite}
				variant="confirm-modal"
				loading={loadingModal}
			>
				<p>
					Tem certeza que deseja remover
					{material?.type_product === "Discipline"
						? " a disciplina"
						: material?.type_product === "Item"
						? " a unidade"
						: material?.type_product === "Theme"
						? " o tema"
						: " o objeto"}{" "}
					<b>{material?.title}</b> de seus favoritos?
				</p>
			</Modal>
		</CardButton>
	);
};
